import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {startRegistrationFlowForCurrentUser} from "../../auth/actions/start_registration_flow_for_current_user";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {useRegistrationWizardExperiment} from "../../auth/hooks/use_registration_wizard_experiment";
import {UnlockChoiceEntryPoint} from "../../auth/types/UnlockChoiceEntryPoint";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useConstructionPhotosUnlockChoice} from "../../offer/hooks/use_construction_photos_unlock_choice";
import {OfferModalActiveTab} from "../../offer/types/OfferModalActiveTab";
import {useAppDispatch} from "../../store/hooks";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {IPropertyDetailOffer} from "../types/IPropertyDetailOffer";

const CONSTRUCTION_STAGES_LABEL = "Zobacz etapy budowy";

interface IUsePropertyConstructionStagesClickParams {
    offer: IPropertyDetailOffer;
    propertyId: number;
    changeModalTab: (tab: OfferModalActiveTab, source?: GTMEventApplicationSourceSection) => void;
}

export const usePropertyConstructionStagesClick = ({offer, propertyId, changeModalTab}: IUsePropertyConstructionStagesClickParams) => {
    const dispatch = useAppDispatch();
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const {hasContent, startConstructionPhotosUnlockChoice} = useConstructionPhotosUnlockChoice(offer);
    const registrationWizardExperiment = useRegistrationWizardExperiment({isEnabled: true});
    const isVerifiedUser = isUserLoggedIn && hasCompleteProfile && hasPhoneVerified;

    return () => {
        trackAmplitudeButtonClick({
            buttonName: "view_construction_stages",
            value: "see_construction_stages",
            buttonCategory: "property_page",
            itemId: offer.id,
            propertyId
        });
        changeModalTab(OfferModalActiveTab.CONSTRUCTION_GALLERY, GTMEventApplicationSourceSection.BANNER);

        if (isVerifiedUser) {
            startConstructionPhotosUnlockChoice();
            return;
        }

        if (!hasContent) {
            return;
        }

        if (registrationWizardExperiment.isResolved && !registrationWizardExperiment.isTreatment) {
            void registrationWizardExperiment.trackExposure();
            return;
        }

        dispatch(
            startRegistrationFlowForCurrentUser(
                {
                    userSource: UserSource.REGISTRATION,
                    gtmSourceSection: GTMEventApplicationSourceSection.MODAL_CONSTRUCTION_GALLERY,
                    titleVariant: AuthModalVariant.CONSTRUCTION_PHOTOS,
                    entryCtaLabel: CONSTRUCTION_STAGES_LABEL,
                    amplitudePlacement: "rp_construction_photos",
                    propertyId,
                    offerId: offer.id,
                    vendorId: offer.vendor.id,
                    unlockChoiceEntryPoint: UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS
                },
                {type: "none"}
            )
        );
    };
};
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {startRegistrationFlowForCurrentUser} from "../../auth/actions/start_registration_flow_for_current_user";
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {useRegistrationWizardExperiment} from "../../auth/hooks/use_registration_wizard_experiment";
import {UnlockChoiceEntryPoint} from "../../auth/types/UnlockChoiceEntryPoint";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useConstructionPhotosUnlockChoice} from "../../offer/hooks/use_construction_photos_unlock_choice";
import {OfferModalActiveTab} from "../../offer/types/OfferModalActiveTab";
import {useAppDispatch} from "../../store/hooks";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {IPropertyDetailOffer} from "../types/IPropertyDetailOffer";

const CONSTRUCTION_STAGES_LABEL = "Zobacz etapy budowy";

interface IUsePropertyConstructionStagesClickParams {
    offer: IPropertyDetailOffer;
    propertyId: number;
    changeModalTab: (tab: OfferModalActiveTab, source?: GTMEventApplicationSourceSection) => void;
}

export const usePropertyConstructionStagesClick = ({offer, propertyId, changeModalTab}: IUsePropertyConstructionStagesClickParams) => {
    const dispatch = useAppDispatch();
    const {isUserLoggedIn, hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();
    const {hasContent, startConstructionPhotosUnlockChoice} = useConstructionPhotosUnlockChoice(offer);
    const registrationWizardExperiment = useRegistrationWizardExperiment({isEnabled: true});
    const isVerifiedUser = isUserLoggedIn && hasCompleteProfile && hasPhoneVerified;

    return () => {
        trackAmplitudeButtonClick({
            buttonName: "view_construction_stages",
            value: "see_construction_stages",
            buttonCategory: "property_page",
            itemId: offer.id,
            propertyId
        });
        changeModalTab(OfferModalActiveTab.CONSTRUCTION_GALLERY, GTMEventApplicationSourceSection.BANNER);

        if (isVerifiedUser) {
            startConstructionPhotosUnlockChoice();
            return;
        }

        if (!hasContent) {
            return;
        }

        if (registrationWizardExperiment.isResolved && !registrationWizardExperiment.isTreatment) {
            void registrationWizardExperiment.trackExposure();
            return;
        }

        dispatch(
            startRegistrationFlowForCurrentUser(
                {
                    userSource: UserSource.REGISTRATION,
                    gtmSourceSection: GTMEventApplicationSourceSection.MODAL_CONSTRUCTION_GALLERY,
                    titleVariant: AuthModalVariant.CONSTRUCTION_PHOTOS,
                    entryCtaLabel: CONSTRUCTION_STAGES_LABEL,
                    amplitudePlacement: "rp_construction_photos",
                    propertyId,
                    offerId: offer.id,
                    vendorId: offer.vendor.id,
                    unlockChoiceEntryPoint: UnlockChoiceEntryPoint.CONSTRUCTION_PHOTOS
                },
                {type: "none"}
            )
        );
    };
};
